import React, {
  ReactElement,
  ReactNode,
  Children,
  cloneElement,
  isValidElement,
} from 'react';
import classnames from 'classnames';

type StepColours = 'primary' | 'secondary' | 'success' | 'dark';

export type StepSizes = 'dot' | 'small' | 'default' | 'large';

export interface StepsProps {
  colour?: StepColours;
  children: ReactNode[];
  size?: StepSizes;
  subheaderText?: string;
  testId?: string;
  vertical?: boolean;
}

export function Steps({
  colour,
  children,
  size = 'default',
  subheaderText = '',
  testId = '',
  vertical = false,
}: StepsProps): ReactElement {
  const classes = classnames('steps', {
    [`steps--${colour}`]: !!colour,
    [`steps--${size}`]: !!size,
    'steps--vertical': vertical,
  });

  return (
    <>
      {subheaderText && (
        <div className="subheader text-center">{subheaderText}</div>
      )}
      <div className={classes} data-testid={testId}>
        {Children.map(children, (child, i) => {
          return isValidElement(child)
            ? cloneElement(child as ReactElement, { step: i + 1 })
            : child;
        })}
      </div>
    </>
  );
}
